module.exports = __webpack_public_path__ + "static/img/stair-Img.1784015206260.png";